import styled from "styled-components";


const LegalWrapper = styled.div`
    padding: 160px 0;
`;

export default LegalWrapper;
